import { PROFILE_STORE_EXPENSES } from './actions';

const initialState = {
    expenses: ''
};

export const profileReducer = ( state = initialState, action ) => {

    let result = '';

    switch ( action.type ) {

        case PROFILE_STORE_EXPENSES:
            result = { ...state, expenses: action.payload };
            break;

        default:
            return state;

    }

    return result;

};